/* eslint-disable */
// @ts-nocheck
export const sendZemantaEvent = (id: string, event: string): void => {
  !(function (_window, _document) {
    if (_window.zemApi) {
      var toArray = function (object) {
        return Object.prototype.toString.call(object) === "[object Array]"
          ? object
          : [object];
      };
      _window.zemApi.marketerId = toArray(_window.zemApi.marketerId).concat(
        toArray(id),
      );
      return;
    }
    var api = (_window.zemApi = function () {
      api.dispatch
        ? api.dispatch.apply(api, arguments)
        : api.queue.push(arguments);
    });
    api.version = "1.0";
    api.loaded = true;
    api.marketerId = id;
    api.queue = [];
    var tag = _document.createElement("script");
    tag.async = true;
    tag.src = "//js-tag.zemanta.com/zcpt.js";
    tag.type = "text/javascript";
    var script = _document.getElementsByTagName("script")[0];
    script.parentNode.insertBefore(tag, script);
  })(window, document);
  zemApi("track", "PAGE_VIEW");
  zemApi("track", event);
};
